<template>
    <div class="my-1">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <i class="fas fa-search position-absolute search-icon"></i>
                <input
                    class="form-control rounded-pill shadow border-2 search-input"
                    type="text"
                    placeholder="მაგ: ადმირალი"
                    autofocus
                    @input="debounceSearch"
                />
            </div>
            <div
                class="spinner-grow text-primary mt-5"
                role="status"
                v-if="loading"
            >
                <span class="visually-hidden">Loading...</span>
            </div>
            <div class="mt-2" v-if="searchResultsCount">
                <small>
                    მოიძებნა
                    <span class="fw-bold">{{ searchResultsCount }}</span>
                    ჩანაწერი
                </small>
            </div>
        </div>
        <div class="row justify-content-center mt-3" v-show="searchValue">
            <SearchCategory :categories="hotels" :name="'hotels'" />
            <SearchCategory :categories="restaurants" :name="'restaurants'" />
            <SearchCategory
                :categories="entertainments"
                :name="'entertainments'"
            />
            <SearchCategory :categories="sights" :name="'sights'" />
            <SearchCategory :categories="transports" :name="'transports'" />
            <SearchCategory :categories="agencies" :name="'agencies'" />
            <SearchCategory :categories="guides" :name="'guides'" />
            <SearchCategory :categories="shops" :name="'shops'" />
            <SearchCategory :categories="schools" :name="'schools'" />
            <SearchCategory :categories="medicines" :name="'medicines'" />
            <SearchCategory :categories="departments" :name="'departments'" />
        </div>
    </div>
</template>

<script>
import { search } from "../Services/ApiService";
import SearchCategory from "./search/SearchCategory.vue";

export default {
    name: "LiveSearch",
    components: { SearchCategory },
    data() {
        return {
            hotels: [],
            restaurants: [],
            entertainments: [],
            agencies: [],
            guides: [],
            sights: [],
            transports: [],
            shops: [],
            schools: [],
            medicines: [],
            departments: [],
            searchValue: null,
            debounce: null,
            loading: false,
        };
    },
    watch: {
        searchValue: {
            handler() {
                if (this.searchValue.length >= 3) this.getResults();
            },
            deep: true,
        },
    },
    computed: {
        searchResultsCount() {
            return (
                this.hotels.length +
                this.restaurants.length +
                this.entertainments.length +
                this.agencies.length +
                this.guides.length +
                this.sights.length +
                this.transports.length +
                this.shops.length +
                this.schools.length +
                this.medicines.length +
                this.departments.length
            );
        },
    },
    methods: {
        getResults() {
            this.loading = true;
            search(this.searchValue)
                .then((res) => {
                    this.loading = false;
                    this.hotels = res.data.hotels;
                    this.restaurants = res.data.restaurants;
                    this.entertainments = res.data.entertainments;
                    this.agencies = res.data.agencies;
                    this.guides = res.data.guides;
                    this.sights = res.data.sights;
                    this.transports = res.data.transports;
                    this.shops = res.data.shops;
                    this.schools = res.data.schools;
                    this.medicines = res.data.medicines;
                    this.departments = res.data.departments;
                })
                .catch(console.error());
        },
        debounceSearch(event) {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.searchValue = event.target.value;
            }, 500);
        },
    },
};
</script>

<style scoped>
.search-icon {
    margin-top: 0.8em;
    margin-left: 0.8em;
    color: #b8b8bd;
}
.search-input {
    padding-left: 2.3em !important;
}
.search-input:focus {
    border: 2px solid #cb0c9f !important;
}
</style>
